module.exports = __webpack_public_path__ + "static/img/dx_pic.c38114f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dx_pic.png
// module id = w3zM
// module chunks = 5